<script>
import { FormWizard, TabContent } from "vue-form-wizard";

export default {
  components: { FormWizard, TabContent },
  props: {
    planoContas: { type: Array, required: true }
  },
  data() {
    return {
      contas: [], // categorias (receitas)
      recebimentos: [], // contas de recebimento
      errors: {},
      titleBody: "Incluir Conta a Receber",
      conta: {
        vencimento: null,
        numeroDocumento: null,
        valorReceber: null,
        descricao: null,
        conta_credito_id: null, // conta de recebimento
        conta_debito_id: null,  // categoria (receita)
        data_recebimento: null,
        status: 0,
        competencia: null,
      },
    };
  },
  created() {
    // Convenção: conta_pgto = 0 → meios de pagamento/recebimento; = 1 → categorias
    this.recebimentos = this.planoContas.filter(c => c.conta_pgto === 0)
    this.contas = this.planoContas.filter(c => c.conta_pgto === 1)
  },
  mounted() {
    this.$emit("newTitle", this.titleBody)
  },
  methods: {
    back() { this.$emit('back') },
    filterContas(descricao) {
      const base = this.planoContas.filter(c => c.conta_pgto === 1)
      this.contas = !descricao ? base : base.filter(c => c.descricao.toLowerCase().includes(descricao.toLowerCase()))
    },
    filterRecebimentos(descricao) {
      const base = this.planoContas.filter(c => c.conta_pgto === 0)
      this.recebimentos = !descricao ? base : base.filter(c => c.descricao.toLowerCase().includes(descricao.toLowerCase()))
    },
    setCategoria(conta) {
      this.conta.conta_debito_id = conta.id
      this.$refs.wizard.nextTab()
    },
    setRecebimento(conta) {
      this.conta.conta_credito_id = conta.id
      this.$refs.wizard.nextTab()
    },
    doPost() {
      const payload = {
        conta_debito_id: this.conta.conta_debito_id,
        conta_credito_id: this.conta.conta_credito_id,
        descricao: this.conta.descricao,
        numero_documento: this.conta.numeroDocumento,
        valor_receber: String(this.conta.valorReceber || '').replace('.', '').replace(',', '.').trim(),
        vencimento: this.conta.vencimento,
        data_emissao: this.conta.vencimento,
        data_recebimento: this.conta.data_recebimento,
        status: this.conta.data_recebimento ? 1 : 0,
        ano_competencia: this.conta.competencia ? parseInt(this.conta.competencia.split('-')[0]) : null,
        mes_competencia: this.conta.competencia ? parseInt(this.conta.competencia.split('-')[1]) : null,
      }
      this.$emit('doPost', payload)
    },
    beforeTabChange(oldIndex) { return this.validateCurrentStep(oldIndex) },
    validateStep1() {
      this.errors = {}
      if (!this.conta.vencimento) this.errors.vencimento = 'Vencimento é obrigatório'
      if (!this.conta.numeroDocumento) this.errors.numeroDocumento = 'Documento é obrigatório'
      if (!this.conta.valorReceber) this.errors.valorReceber = 'Valor é obrigatório'
      return Object.keys(this.errors).length === 0
    },
    validateStep2() {
      this.errors = {}
      if (!this.conta.conta_debito_id) this.errors.conta_debito_id = 'Categoria é obrigatória'
      return Object.keys(this.errors).length === 0
    },
    validateStep3() {
      this.errors = {}
      if (!this.conta.conta_credito_id) this.errors.conta_credito_id = 'Conta de recebimento é obrigatória'
      return Object.keys(this.errors).length === 0
    },
    validateStep4() { this.errors = {}; return true },
    validateCurrentStep(step) {
      switch (step) {
        case 0: return this.validateStep1()
        case 1: return this.validateStep2()
        case 2: return this.validateStep3()
        case 3: return this.validateStep4()
      }
    }
  }
}
</script>

<template>
  <form-wizard color="#556ee6"
    ref="wizard"
    next-button-text="Avançar"
    finish-button-text="Gravar"
    back-button-text="Voltar"
    @on-complete="doPost"
    :before-change="beforeTabChange"
  >
    <tab-content icon="mdi mdi-file-percent" :before-change="validateStep1">
      <div class="row">
        <div class="col-md-2">
          <label for="vencimento">Vencimento</label>
          <input type="date" class="form-control" id="vencimento" v-model="conta.vencimento" ref="vencimento">
          <span v-if="errors.vencimento" class="error">{{ errors.vencimento }}</span>
        </div>
        <div class="col-md-2">
          <label for="competencia">Competência</label>
          <b-form-input type="month" class="form-control" id="competencia" v-model="conta.competencia" ref="competencia" />
        </div>
        <div class="col-md-6">
          <label for="numeroDocumento">Documento</label>
          <input type="text" class="form-control" id="numeroDocumento" v-model="conta.numeroDocumento" ref="numeroDocumento">
          <span v-if="errors.numeroDocumento" class="error">{{ errors.numeroDocumento }}</span>
        </div>
        <div class="col-md-2">
          <label for="valorReceber">Valor R$</label>
          <input type="text" class="form-control text-right" id="valorReceber" ref="valorReceber"
            v-model="conta.valorReceber"
          >
          <span v-if="errors.valorReceber" class="error">{{ errors.valorReceber }}</span>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <label for="descricao">Histórico (descrição)</label>
          <input type="text" class="form-control" id="descricao" v-model="conta.descricao">
        </div>
      </div>
    </tab-content>

    <tab-content icon="mdi mdi-file-tree" :before-change="validateStep2">
      <h2>Selecionar Categoria</h2>
      <b-row cols="1">
        <div class="position-relative">
          <form class="app-search d-none d-lg-block" @submit.prevent>
            <div class="position-relative">
              <input name="contaContabil" type="text" class="form-control" placeholder="Buscar por Categoria" @input="filterContas($event.target.value)" ref="conta_debito_id" />
              <span class="ri-search-line"></span>
            </div>
          </form>
        </div>
        <span v-if="errors.conta_debito_id" class="error">{{ errors.conta_debito_id }}</span>
      </b-row>
      <div class="row">
        <div class="col-12 max-h-96 overflow-y-auto">
          <b-row cols="1" v-for="conta in contas" :key="conta.id" class="cursor-pointer">
            <b-col @click="setCategoria(conta)">
              <b-card class="flex" :class="(conta.conta_debito_id === conta.id) ? 'bg-light' : 'bg-default'">
                <b-badge variant="primary" class="w-12 h-12 rounded-full items-center justify-center pt-8">
                  <span class="text-lg font-semibold">{{ conta.descricao.substring(0, 1) }}</span>
                </b-badge>
                <span class="flex items-center ml-3">{{ conta.descricao }}</span>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </div>
    </tab-content>

    <tab-content icon="mdi mdi-bank-transfer" :before-change="validateStep3">
      <h2>Selecionar Conta de Recebimento</h2>
      <b-row cols="1">
        <div class="position-relative">
          <form class="app-search d-none d-lg-block" @submit.prevent>
            <div class="position-relative">
              <input name="contaReceb" type="text" class="form-control" placeholder="Buscar por Conta de Recebimento" @input="filterRecebimentos($event.target.value)" ref="conta_credito_id" />
              <span class="ri-search-line"></span>
            </div>
          </form>
        </div>
        <span v-if="errors.conta_credito_id" class="error">{{ errors.conta_credito_id }}</span>
      </b-row>
      <div class="row">
        <div class="col-12 max-h-96 overflow-y-auto">
          <b-row cols="1" v-for="rec in recebimentos" :key="rec.id" class="cursor-pointer">
            <b-col @click="setRecebimento(rec)">
              <b-card class="flex" :class="(conta.conta_credito_id === rec.id) ? 'bg-light' : 'bg-default'">
                <b-badge variant="primary" class="w-12 h-12 rounded-full items-center justify-center pt-8">
                  <span class="text-lg font-semibold">{{ rec.descricao.substring(0, 1) }}</span>
                </b-badge>
                <span class="flex items-center ml-3">{{ rec.descricao }}</span>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </div>
    </tab-content>

    <tab-content icon="mdi mdi-calendar" :before-change="validateStep4">
      <h2>Data de Recebimento</h2>
      <b-row cols="1">
        <div class="col-md-3 col-sm-12">
          <label for="data_recebimento">Data de Recebimento</label>
          <input type="date" class="form-control" id="data_recebimento" v-model="conta.data_recebimento" ref="data_recebimento">
        </div>
      </b-row>
    </tab-content>
  </form-wizard>
</template>

<style>
.w-12 { width: 3rem; }
.h-12 { height: 3rem; }
.text-lg { font-size: 1.900rem; line-height: 1.75rem; }
.rounded-full { border-radius: 9999px; }
.justify-center { justify-content: center; }
.font-semibold { font-weight: 600; }
.items-center { align-items: center; }
.pt-8 { padding-top: 0.5rem; }
.max-h-96 { max-height: 24rem; }
.overflow-y-auto { overflow-y: auto; }
.cursor-pointer { cursor: pointer; }
</style>


